import AjaxClass from '@/ajax'

export default class AttestationService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  getTestQuestions (then) {
    return this.ajax.get('/attestation/test', {random: true}, (data) => {
      return then(data.list)
    })
  }

  getThematicQuestions (then) {
    return this.ajax.get('/attestation/thematic', {random: true}, (data) => {
      return then(data.list)
    })
  }

  getPracticeQuestions (then) {
    return this.ajax.get('/attestation/practice', {random: true}, (data) => {
      return then(data.list)
    })
  }

  saveTestAnswer (questionId, answerId, then) {
    return this.ajax.post('/attestation/test_answer', {questionId: questionId, answerId: answerId}, (data) => {
      return then(data)
    }, {hiddenLoading: true})
  }

  saveThematicAnswer (questionId, answerId, then) {
    return this.ajax.post('/attestation/thematic_answer', {questionId: questionId, answerId: answerId}, (data) => {
      return then(data)
    }, {hiddenLoading: true})
  }

  savePracticeAnswer (questionId, answerId, then) {
    return this.ajax.post('/attestation/practice_answer', {questionId: questionId, answerId: answerId}, (data) => {
      return then(data)
    }, {hiddenLoading: true})
  }

  endTestStage (then) {
    return this.ajax.post('/attestation/test_end', {end: true}, (data) => {
      return then(data)
    })
  }

  endThematicStage (then) {
    return this.ajax.post('/attestation/thematic_end', {end: true}, (data) => {
      return then(data)
    })
  }

  endPracticeStage (then) {
    return this.ajax.post('/attestation/practice_end', {end: true}, (data) => {
      return then(data)
    })
  }

  getResult (id, then, full = true) {
    return this.ajax.get('/attestation/result', {id: id, full: full}, (data) => {
      return then(data)
    })
  }

  setTime (time) {
    if ((time % 10) === 0) {
      return this.ajax.post('/attestation/save_student_attestation_time', {time: time}, (data) => {
      }, {hiddenLoading: true})
    }
  }

  startAttestation (groupId, then) {
    return this.ajax.get('/attestation/start', {id: groupId}, (data) => {
      return then(data)
    })
  }

  endAttestation (groupId, then) {
    return this.ajax.get('/attestation/end', {id: groupId}, (data) => {
      return then(data)
    })
  }

  startTraining (groupId, then) {
    return this.ajax.get('/attestation/start_training', {id: groupId}, (data) => {
      return then(data)
    })
  }

  endTraining (groupId, then) {
    return this.ajax.get('/attestation/end_training', {id: groupId}, (data) => {
      return then(data)
    })
  }

  startStudentAttestation (then) {
    return this.ajax.post('/attestation/attestation_start', {}, (data) => {
      return then(data)
    })
  }

  getStudentAttestationInfo (then) {
    return this.ajax.get('/attestation/attestation_student_info', {}, (data) => {
      return then(data)
    })
  }

  resultToPdf (id, then) {
    return this.ajax.get('/attestation/resultToPdf', {id: id}, (data) => {
      return then(data)
    }, {
      responseType: 'blob'
    })
  }

  isTraining (callback) {
    return this.ajax.get('/attestation/is_training', {}, (data) => {
      callback(data)
    })
  }

  getTrainingResults (callback) {
    this.ajax.get('/attestation/training_results', {}, (data) => {
      callback(data)
    })
  }

  getTrainingStudentResults (id, callback) {
    this.ajax.get('/attestation/training_student_results', {id: id}, (data) => {
      callback(data)
    })
  }

  getAttestationResults (id, callback) {
    this.ajax.get('/attestation/attestation_student_results', {id: id}, (data) => {
      callback(data)
    })
  }

  getStudentAttestationInfoById (id, callback) {
    this.ajax.get('/attestation/student_attestation_info', {id: id}, (data) => {
      callback(data)
    })
  }

  needFilter (id, then) {
    return this.ajax.get('/attestation/need_filter', {id: id}, (data) => {
      then(data)
    })
  }

  saveFilter (id, need, then) {
    return this.ajax.post('/attestation/save_filter', {id: id, need: need}, (data) => {
      return then(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/AttestationService.js